import React from 'react';
import { UserAvatar } from '../avatar';
import {
  StyledMentionSuggestion,
  MentionContent,
  MentionName,
  MentionUsername,
} from './style';

const MentionSuggestion = ({ entry, focused }) => {
  return (
    <StyledMentionSuggestion focused={focused}>
      <MentionContent>
        <MentionUsername focused={focused}>
          @{entry.display}
        </MentionUsername>
      </MentionContent>
    </StyledMentionSuggestion>
  );
};

export default MentionSuggestion;
